import { EPaymentMethodType } from '../../../../types/redux/paymentMethods';
import { TYooMoneyPaymentMethods } from '../../../../types/yooMoney';

type TMap = { [key in EPaymentMethodType]: TYooMoneyPaymentMethods };

const PAYMENT_METHODS_MAP: TMap = {
  sbp: 'sbp',
  others: 'bank_card',
} as TMap;

export const getYooMoneyPaymentType = (paymentMethodType: EPaymentMethodType): TYooMoneyPaymentMethods => {
  return PAYMENT_METHODS_MAP[paymentMethodType];
};
